export default __webpack_public_path__ + "static/media/58e18c0d3e8bbc19.694bd5a818b0cb690d800491e436940f.svg";